import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	background: transparent;
	flex: 1 1 auto; /* Allow growing and shrinking */
	min-width: 0; /* This is crucial for text truncation to work in flex containers */
	margin-top: 2px;
`;

export const Label = styled.div`
	// layout
	display: inline-block;
	align-items: center;
	margin-top: -2px;
	width: 100%;
	max-width: 100%;

	// style
	user-select: none;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
